export class RatingRange {
    rating: string = '';
    range: number[] = [];
}

export const trackRatingMap: RatingRange[] = [
    {
        rating: 'Firm', 
        range: [1, 2]
    },
    {
        rating: 'Good', 
        range: [3, 4]
    },
    {
        rating: 'Soft', 
        range: [5, 7]
    },
    {
        rating: 'Heavy', 
        range: [8, 10]
    },
];